import styled, { css } from 'styled-components';
export const Item = styled.div `
  display: flex;

  justify-content: space-between;

  border-radius: var(--radius-brand);
  padding: var(--space-200) var(--space-200) var(--space-200) var(--space-300);

  background: var(--bg-secondary);

  cursor: pointer;

  ${({ $active }) => $active &&
    css `
      outline: 2px solid var(--border-active);
    `}
`;
export const Wrapper = styled.div `
  align-self: center;
`;
export const Container = styled.div `
  display: flex;
  gap: var(--space-300);
  align-self: center;
`;
export const Text = styled.div `
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-400);
`;
